import { ReactNode } from 'react';

import { ListingViewBodyHolder } from './ListingViewBody.styled';

type Props = {
  children: ReactNode;
};

export function ListingViewBody({ children }: Props) {
  return <ListingViewBodyHolder>{children}</ListingViewBodyHolder>;
}
